import React from 'react';
import { Routes, Route } from 'react-router-dom';
import InventoryList from './InventoryList';
import InventoryForm from './InventoryForm';

const Inventories = () => {
  return (
    <Routes>
      <Route index element={<InventoryList />} />
      <Route path="new" element={<InventoryForm />} />
      <Route path=":id/edit" element={<InventoryForm />} />
    </Routes>
  );
};

export default Inventories;
